export const fr = {
  onboardingPage: {
    companyDoesNotExistModal: {
      title: "Nous n'avons pas trouvé votre entreprise",
      message:
        'Votre entreprise est-elle intéressée par une inscription à Purposely ? Réservez une démo pour en savoir plus !',
      buttons: {
        confirm: 'Réserver une démo',
        cancel: 'Retour',
      },
    },
    employeeLanding: {
      title: "Page d'accueil des employés",
      benefits: {
        contribute:
          'Contribuez à votre communauté et aux causes qui vous tiennent à cœur',
        learn: 'Apprenez de nouvelles compétences',
        share: 'Partagez vos compétences',
        activities:
          'Participez à des activités amusantes avec vos collègues qui profitent aussi à votre communauté',
        connect: 'Rencontrez de nouvelles personnes',
      },
      links: {
        signup: 'Commencer',
        login: 'Se connecter',
      },
    },
    causes: {
      title: 'Préférences de causes',
      subtitle:
        'Quelles causes souhaitez-vous soutenir à travers le bénévolat ?',
      hint: 'Pour nous aider à personnaliser votre expérience, nous vous recommandons de sélectionner un maximum de 5 causes',
      buttons: {
        next: 'Suivant',
      },
      validation: {
        max_causes: 'Veuillez sélectionner au maximum 5 causes',
      },
    },
    companyDoesNotExist: {
      title:
        "Nous n'avons pas trouvé d'entreprise utilisant votre domaine email. Mais ne perdez pas espoir.",
      options: {
        wrong_email:
          "Si vous êtes un employé d'une entreprise utilisant Purposely mais que vous avez utilisé le mauvais email, réessayez avec votre email professionnel.",
        nonprofit:
          'Si vous êtes une organisation à but non lucratif, créez un compte association ici.',
        connect:
          'Si vous pensez que votre entreprise pourrait bénéficier de Purposely, mettez-nous en contact avec vos responsables.',
        register:
          'Si vous souhaitez inscrire votre entreprise sur Purposely, réservez une démo',
      },
    },
    generalInfoForm: {
      labels: {
        profile_photo: 'Photo de profil',
        full_name: 'Nom complet',
        department: 'Département',
        location: 'Emplacement',
        team_lead:
          'Gérez-vous ou dirigez-vous une équipe chez {{companyName}} ?',
        preferred_language: 'Langue préférée',
      },
      placeholders: {
        full_name: 'Votre nom complet',
      },
      validation: {
        required: 'Requis',
        required_with_dot: 'Requis.',
      },
      choices: {
        yes: 'Oui',
        no: 'Non',
      },
      buttons: {
        save: 'Enregistrer',
      },
      errors: {
        image_upload: "Erreur lors du téléchargement de l'image :",
        invalid_format: "Format d'image invalide",
      },
    },
  },
}
